"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = require("../base/styled");
var _styled2 = require("./styled");
var _validationSpan = _interopRequireDefault(require("./validation-span"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Collapsible = function Collapsible(_ref) {
  var title = _ref.title,
    open = _ref.open,
    children = _ref.children,
    onCollapse = _ref.onCollapse,
    isValid = _ref.isValid,
    id = _ref.id,
    showDivider = _ref.showDivider,
    showValidateIcon = _ref.showValidateIcon,
    $bsStyle = _ref.$bsStyle,
    bodyStyle = _ref.bodyStyle,
    titleStyle = _ref.titleStyle,
    titleInfo = _ref.titleInfo,
    components = _ref.components;
  return /*#__PURE__*/_react.default.createElement(_styled2.Section, {
    $bsStyle: $bsStyle
  }, /*#__PURE__*/_react.default.createElement(_styled2.TitleSection, {
    id: id,
    titleStyle: titleStyle,
    className: "title",
    onClick: onCollapse
  }, /*#__PURE__*/_react.default.createElement(_styled.Row, {
    id: id
  }, title, /*#__PURE__*/_react.default.createElement(_styled2.TitleInfoWrapper, null, titleInfo)), /*#__PURE__*/_react.default.createElement(components.IconContainer, {
    className: "icons"
  }, /*#__PURE__*/_react.default.createElement(_validationSpan.default, {
    show: !open && showValidateIcon,
    isValid: isValid
  }), /*#__PURE__*/_react.default.createElement(_styled2.Arrow, {
    id: id,
    className: "icon",
    onClick: onCollapse,
    isOpen: open
  }))), /*#__PURE__*/_react.default.createElement(_styled2.BodySection, {
    className: "body",
    open: open,
    $bsStyle: bodyStyle
  }, open && children), showDivider && /*#__PURE__*/_react.default.createElement(_styled.Hr, {
    margin: "0"
  }));
};
Collapsible.propTypes = {
  onCollapse: _propTypes.default.func.isRequired,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  id: _propTypes.default.string.isRequired,
  open: _propTypes.default.bool,
  isValid: _propTypes.default.bool,
  showDivider: _propTypes.default.bool,
  showValidateIcon: _propTypes.default.bool,
  $bsStyle: _propTypes.default.shape({}),
  children: _propTypes.default.node.isRequired,
  bodyStyle: _propTypes.default.shape({}),
  titleStyle: _propTypes.default.shape({}),
  titleInfo: _propTypes.default.string,
  components: _propTypes.default.shape({
    IconContainer: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.shape({}), _propTypes.default.element, _propTypes.default.elementType])
  })
};
Collapsible.defaultProps = {
  open: false,
  isValid: false,
  showDivider: true,
  showValidateIcon: true,
  $bsStyle: null,
  bodyStyle: null,
  titleStyle: null,
  titleInfo: '',
  components: {
    IconContainer: _styled2.IconsWrapper
  }
};
var _default = Collapsible;
exports.default = _default;